<template>
	<div v-if="header.component">
		<component
			v-if="header.nonObject"
			:is="header.component()"
			v-model:data="componentNonObjData"
		/>
		<component
			v-else
			:is="header.component()"
			v-model:data="componentData"
		/>
	</div>

	<div
		v-else-if="header.slot"
		class="slot-wrapper"
	>
		<slot
			:name="header.slot"
			v-bind="row"
			>[Data Missing]</slot
		>
	</div>

	<div v-else>
		<span
			v-if="availableActions.length > 0"
			class="action-cell"
		>
			<span
				v-for="action in availableActions"
				:key="action.name"
				class="rich-table-actions"
			>
				<TooltipComponent
					v-if="getValue(action.tooltip)"
					:tooltip="getValue(action.tooltip)"
					style="text-transform: none"
					direction="top"
				>
					<template #showFromOutside>
						<button
							v-if="getValue(action.type) === 'button'"
							:class="action.cssClass"
							:disabled="getValue(action.disabled)"
							@click.stop="action.action(row, rowIndex, tableData)"
						>
							<span v-if="action.icon"><i :class="getActionIconClass(action)" /></span>
							<span v-if="action.text">{{ getValue(action.text) }}</span>
						</button>

						<a
							v-else-if="getValue(action.type) === 'link'"
							href="#"
							:class="action.cssClass"
							@click.stop.prevent="action.action(row, rowIndex, tableData)"
						>
							<span v-if="action.text">{{ getValue(action.text) }}</span>
						</a>

						<router-link
							v-else-if="getValue(action.type) === 'route'"
							:class="action.cssClass"
							:to="action.action(row, rowIndex, tableData)"
							@click.stop="action.click ? action.click(row, rowIndex, tableData) : () => {}"
						>
							<span v-if="action.text">{{ getValue(action.text) }}</span>
						</router-link>
					</template>
				</TooltipComponent>

				<template v-else>
					<button
						v-if="getValue(action.type) === 'button'"
						:class="action.cssClass"
						:disabled="getValue(action.disabled)"
						@click.stop="action.action(row, rowIndex, tableData)"
					>
						<span v-if="action.icon"><i :class="getActionIconClass(action)" /></span>
						<span v-if="action.text">{{ getValue(action.text) }}</span>
					</button>

					<a
						v-else-if="getValue(action.type) === 'link'"
						href="#"
						:class="action.cssClass"
						@click.stop.prevent="action.action(row, rowIndex, tableData)"
					>
						<span v-if="action.text">{{ getValue(action.text) }}</span>
					</a>

					<router-link
						v-else-if="getValue(action.type) === 'route'"
						:class="action.cssClass"
						:to="action.action(row, rowIndex, tableData)"
						@click.stop="action.click ? action.click(row, rowIndex, tableData) : () => {}"
					>
						<span v-if="action.text">{{ getValue(action.text) }}</span>
					</router-link>

					<span v-else>
						{{ getValue(action.type) }}
					</span>
				</template>
			</span>
		</span>

		<span v-else>{{ header.rowValue(row) }}</span>
	</div>
</template>
<script>
	import util from '@core/services/util';
	import RichTableHeader from '@core/classes/RichTableHeader';
	import TooltipComponent from '@core/components/TooltipComponent.vue';

	export default {
		name: 'RichTableDataCell',
		emits: ['click'],
		props: {
			tableData: Array,
			rowIndex: Number,
			header: RichTableHeader,
			row: Object,
		},
		data() {
			return {};
		},
		computed: {
			availableActions() {
				if (!this.header?.actions || this.header.actions.length < 1) return [];

				return this.header.actions.filter(a => {
					let actionType = util.isFunction(a.type) ? a.type(this.row) : a.type;
					return !a.header && !util.isNull(actionType);
				});
			},
			componentNonObjData() {
				return {
					nameValue: this.row._ref[this.header.name],
					modelValue: this.header.value,
					row: this.row,
				};
			},
			componentData() {
				return { ...this.row[this.header.name] };
			},
		},

		methods: {
			getValue(value) {
				return util.isFunction(value) ? value(this.row) : value;
			},
			getActionIconClass(action) {
				if (!action.icon) return '';
				return action.icon.indexOf('fas') !== -1 ? action.icon : 'fas ' + action.icon;
			},
		},
		components: {
			TooltipComponent,
		},
	};
</script>
